import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import EmailIcon from "@mui/icons-material/Email";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControlLabel,
  Link,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PolicyHistory from "../../../../../Components/Broker/PolicyHistory/PolicyHistory";
import SelectvoluntryPlans from "../../../../../Components/Broker/SelectVoluntryPlans/SelectVoluntryPlans";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import MultipleSearchDropdown from "../../../../../Supporting files/MultipleSearchDropdown/MultipleSearchDropdown";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import UGEmailInput from "../../../../../Supporting files/UGEmailInput/UGEmailInput";
import "../../../../../formLayout.scss";
import Exclusion from "../Exclusion/Exclusion";
import SelectFeature from "../SelectFeature/SelectFeature";

function AddNewQuotes() {
  const navigate = useNavigate();
  const [productType, setProductType] = useState<"Health" | "SuperTopup">(
    "Health"
  );
  const [salaryBracket, setSalaryBracket] = React.useState("");
  const [designationOne, setDesignationOne] = React.useState("");
  const [departmentOne, setDepartmentOne] = React.useState("");
  const [deductible, setDeductible] = React.useState("");
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("businesscard");
  const [organizationName, setOrganizationName] = React.useState("");
  const [ownership, setOwnership] = React.useState("");
  const [corporateAmount, setCorporateAmount] = React.useState("");
  const [planType, setPlanType] = React.useState(0);
  const [familyDefinition, setFamilyDefinition] = React.useState(
    "Employee, Spouse & 2 dependant Children up to the age of 25 years"
  );
  const [location, setLocation] = React.useState("");
  const [location2, setLocations2] = React.useState("");
  const [location3, setLocations3] = React.useState("");
  const [location4, setLocations4] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [subIndustry, setSubIndustry] = React.useState("");
  const [totalNoOfLives, setTotalNoOfLives] = React.useState("");
  const [spoc, setSpoc] = React.useState("");
  const [sumInsuredOne, setSumInsuredOne] = React.useState("₹ 3,000,00");
  const [attachment, setAttachment] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [clientID, setClientID] = React.useState("");
  const [toggle, setToggle] = React.useState(true);
  const [show, setShow] = useState(false);
  const [email, setEmail] = React.useState("");
  const [websiteUrl, setWebsiteUrl] = React.useState("");
  const [contactNo, setContactNo] = React.useState("");
  const [showNominee, setShowNominee] = useState(false);
  const [enrolmentPeriod, setEnrolmentPeriod] = React.useState("");
  const [policyType, setPolicyType] = React.useState(0);
  const [locations, setLocations] = React.useState("");
  const [kids, setKids] = React.useState("");
  const [employees, setEmployees] = React.useState("");
  const [showhealth, setShowhealth] = useState(false);
  const [spouse, setSpouse] = React.useState("");
  const [insurer1, setInsurer1] = React.useState("");
  const [insurer2, setInsurer2] = React.useState("");
  const [insurer3, setInsurer3] = React.useState("");
  const [insurer4, setInsurer4] = React.useState("");
  const [othersGraded, setOthersGraded] = React.useState("");
  const [totalKids, setTotalKids] = React.useState("");
  const [insurerOne, setInsurerOne] = React.useState("");
  const [emailcomp, setEmailComp] = React.useState(false);
  const [netpremium1, setNetPremium1] = React.useState("");
  const [netpremium2, setNetPremium2] = React.useState("");
  const [netpremium3, setNetPremium3] = React.useState("");
  const [netpremium4, setNetPremium4] = React.useState("");
  const [tax, setTax] = React.useState("");
  const [tax2, setTax2] = React.useState("");
  const [tax3, setTax3] = React.useState("");
  const [tax4, setTax4] = React.useState("");
  const [showcorporate, setShowcorporate] = useState(false);
  const [cardType, setCardType] = React.useState("");
  const [healthcardIssued, setHealthCardIssued] = React.useState("");
  const [corporatebufferValue, setCorporateBufferValue] = React.useState("");
  const [grosspremium1, setGrossPremium1] = React.useState("");
  const [grosspremium2, setGrossPremium2] = React.useState("");
  const [grosspremium3, setGrossPremium3] = React.useState("");
  const [grosspremium4, setGrossPremium4] = React.useState("");
  const [insurerOffice, setInsurerOffice] = React.useState("");
  const [insurerFour, setInsurerFour] = React.useState("");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [basicConfiguration, setBasicConfiguration] = React.useState("");
  const [indvConfiguration, setIndvConfiguration] = React.useState("");
  const [addPremium, setAddPremium] = React.useState(false);
  const [contactNumber, setContactNumber] = React.useState("");
  const [enrollPeriod, setEnrollPeriod] = React.useState("");
  const [employeeenrollmentPeriod, setEmployeeEnrollmentPeriod] =
    React.useState("");
  const [maximunMembers, setMaximunMembers] = React.useState("");
  const [totalNumbers, setTotalNumbers] = React.useState("");
  const [organizationEmail, setOrganizationEmail] = React.useState("");
  const [addFeature, setAddFeature] = React.useState(false);
  const [selectvoluntryPlans, setSelectVoluntryPlans] = React.useState(false);
  const [Addexclusion, setAddExclusion] = React.useState(false);
  const [exclusion, setExclusion] = React.useState(false);
  const [websiteURL, setWebsiteURL] = React.useState("");
  const [gracePeriod, setGracePeriod] = React.useState("");
  const [maximumNominee, setMaximumNominee] = React.useState("");
  const [employeeAge, setEmployeeAge] = React.useState("");
  const [spouseAge, setSpouseAge] = React.useState("");
  const [gradeLives1, setGradeLives1] = React.useState("100");
  const [sonAge, setSonAge] = React.useState("");
  const [daughterAge, setDaughterAge] = React.useState("");
  const [cDBalance, setCDBalance] = React.useState("");
  const [cDBalancePercent, setCDBalancePercent] = React.useState("");
  const [employeePayment, setEmployeePayment] = React.useState("%");
  const [spousePayment, setSpousePayment] = React.useState("%");
  const [childrenPayment, setChildrenPayment] = React.useState("%");
  const [parentsPayment, setParentsPayment] = React.useState("%");
  const [parentsinLawPayment, setParentsInLawPayment] = React.useState("%");
  const [expanded, setExpanded] = React.useState<string | false>("panel");
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(new Date());
  const [enrollstartDate, setEnrollStartDate] = React.useState<Date | null>(
    new Date()
  );
  const [gradedDesignation, setGradedDesignation] = React.useState("");
  const [enrollendDate, setEnrollEndDate] = React.useState<Date | null>(
    new Date()
  );
  const [policyEndDate, setPolicyEndDate] = React.useState<Date | null>(
    new Date()
  );
  const [policyStartDate, setPolicyStartDate] = React.useState<Date | null>(
    new Date()
  );
  const [firstCategoryAgeGroup, setfirstCategoryAgeGroup] = React.useState("");
  const [secondCategoryAgeGroup, setSecondCategoryAgeGroup] =
    React.useState("");
  const [thirdCategoryAgeGroup, setThirdCategoryAgeGroup] = React.useState("");
  const [fourthCategoryAgeGroup, setFourthCategoryAgeGroup] =
    React.useState("");
  const [firstSpouseCategoryAgeGroup, setfirstSpouseCategoryAgeGroup] =
    React.useState("");
  const [secondSpouseCategoryAgeGroup, setSecondSpouseCategoryAgeGroup] =
    React.useState("");
  const [thirdSpouseCategoryAgeGroup, setThirdSpouseCategoryAgeGroup] =
    React.useState("");
  const [fourthSpouseCategoryAgeGroup, setFourthSpouseCategoryAgeGroup] =
    React.useState("");
  const [empGradeData, setEmpGradeData] = useState<
    Array<{
      sum_insured: string;
      emp_count: string;
      deleteable: boolean;
      features: Array<string>;
    }>
  >([{ sum_insured: "", emp_count: "", deleteable: false, features: [] }]);
  // for scrolling
  const organizationDetails = useRef(null);
  const products = useRef(null);
  const plantype = useRef(null);
  const EmployeeDetails = useRef(null);
  const premiumdetails = useRef(null);
  const paymenttype = useRef(null);
  const attatchments = useRef(null);
  const emailsection = useRef(null);
  const tasks = useRef(null);
  const notes = useRef(null);
  const detailspolicy = useRef(null);

  const scrollToSection = (elementRef: any) => {
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  const handleClick =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const [rateData, setRateData] = React.useState([
    [
      { key: "one", value: "₹ 2145" },
      { key: "two", value: "₹ 2145" },
      { key: "three", value: "₹ 2145" },
      { key: "four", value: "₹ 2145" },
      { key: "five", value: "₹ 2145" },
      { key: "six", value: "₹ 2145" },
      { key: "seven", value: "₹ 2145" },
      { key: "eight", value: "₹ 2145" },
      { key: "nine", value: "₹ 2145" },
    ],
  ]);

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName[0] === "rateData") {
      let data = rateData;
      data[attrName[1]][attrName[2]].value = value;
      setRateData([...data]);
    } else {
      let data: any = [...rateData];
      setRateData([...data]);

      if (attrName === "notes_new_data") {
        setNotesData((notesData) => [
          ...notesData,
          { name: "rOHIT", date: new Date(), description: value },
        ]);
      } else if (attrName === "addFeature") {
        attrName(value);
      } else {
        attrName(value);
      }
    }
  };

  const [ageData, setAgeData] = React.useState([
    [
      { key: "one", value: "10" },
      { key: "two", value: "10" },
      { key: "three", value: "10" },
      { key: "four", value: "10" },
      { key: "five", value: "10" },
      { key: "six", value: "10" },
      { key: "seven", value: "10" },
      { key: "eight", value: "10" },
      { key: "nine", value: "10" },
    ],
  ]);

  function toggleShow() {
    setShow(!show);
  }
  function toggleShowNominee() {
    setShowNominee(!showNominee);
  }
  function toggleShowhealth() {
    setShowhealth(!showhealth);
  }
  function toggleShowcorporate() {
    setShowcorporate(!showcorporate);
  }
  const handleClicked = () => {
    setToggle(false);
  };
  const handleClicktoogle = () => {
    setToggle(true);
  };

  const [livesinformationData, setLivesInformationData] = React.useState([
    {
      min_age: "",
      max_age: "",
      relationship: "",
      noof_lives: "",
    },
  ]);

  const handleClickone = () => {
    setToggle(false);
  };
  const handleClicktwo = () => {
    setToggle(true);
  };

  const sumInsuredOne_data = [
    { key: "₹ 3,00,000", value: "₹ 3,00,000" },
    { key: "₹ 4,00,000", value: "₹ 4,00,000" },
  ];
  const ownership_data = [
    { key: "Private Limited", value: "Private Limited" },
    { key: "Partnership", value: "Partnership" },
  ];
  const industry_data = [
    { key: "IT", value: "IT" },
    { key: "Manufacturing", value: "Manufacturing" },
    { key: "Construction", value: "Construction" },
    { key: "Education", value: "Education" },
    { key: "Chemical Industries", value: "Chemical Industries" },
    { key: "Critical Illness Add-on", value: "Critical Illness Add-on" },
  ];
  const subIndustry_data = [
    { key: "Software & Services", value: "Software & Services" },
    { key: "Semiconductor Equipment", value: "Semiconductor Equipment" },
    { key: "Hardware Technology", value: "Hardware Technology" },
  ];
  const locations_data = [
    { key: "Evervent- Mohali", value: "Evervent- Mohali" },
    { key: "Evervent- Mumbai", value: "Evervent- Mumbai" },
    { key: "Evervent- Jaipur", value: "Evervent- Jaipur" },
  ];
  const officeAddress_data = [
    { label: "Mohali", value: "Mohali" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Dehradun", value: "Dehradun" },
    { label: "Karnal", value: "Karnal" },
  ];
  const basicConfig_data = [
    { key: "1E+1S+1C+1C+1C+1C", value: "1E+1S+1C+1C+1C+1C" },
    { key: "1E+1S+1C+1C+1C", value: "1E+1S+1C+1C+1C" },
    { key: "1E+1S+1C+1C", value: "1E+1S+1C+1C" },
    { key: "1E+1S+1C", value: "1E+1S+1C" },
    { key: "1E+1S", value: "1E+1S" },
    { key: "1E", value: "1E" },
  ];
  const indvConfig_data = [
    { key: "Nill", value: "Nill" },
    { key: "1P+1P ", value: "1P+1P " },
    { key: "1PIL+1PIL", value: "1PIL+1PIL" },
    { key: "1P+1P+1PIL+1PIL", value: "1P+1P+1PIL+1PIL" },
  ];
  const insureroffice_data = [
    { key: "Evervent - Mohali", value: "Evervent - Mohali" },
    { key: "Evervent - New Delhi", value: "Evervent - New Delhi" },
    { key: "Evervent - Bangluru", value: "Evervent - Bangluru" },
  ];
  const clientid_data = [
    { label: "CLT012 - Evervent", value: "CLT012 - Evervent" },
    { label: "CLT013 - Evervent", value: "CLT013 - Evervent" },
    { label: "CLT014 - Evervent", value: "CLT014 - Evervent" },
    { label: "CLT015 - Evervent", value: "CLT015 - Evervent" },
  ];
  const enrollperiod_data = [
    { key: "15 Days", value: "15 Days" },
    { key: "30 Days", value: "30 Days" },
    { key: "45 Days", value: "45 Days" },
    { key: "60 Days", value: "60 Days" },
    { key: "90 Days", value: "90 Days" },
  ];
  const graceperiod_data = [
    { key: "5 Days", value: "5 Days" },
    { key: "6 Days", value: "6 Days" },
    { key: "7 Days", value: "7 Days" },
    { key: "8 Days", value: "8 Days" },
    { key: "9 Days", value: "9 Days" },
    { key: "10 Days", value: "10 Days" },
  ];
  const employeeEnrollmentPeriod_data = [
    { key: "15 Days", value: "15 Days" },
    { key: "30 Days", value: "30 Days" },
    { key: "45 Days", value: "45 Days" },
    { key: "60 Days", value: "60 Days" },
    { key: "90 Days", value: "90 Days" },
  ];
  const totalNumber_data = [
    { key: "4", value: "4" },
    { key: "6", value: "6" },
    { key: "5", value: "5" },
    { key: "7", value: "7" },
    { key: "3", value: "3" },
  ];
  const insurer_data = [
    { label: "Sbi", value: "SBI General Insurance" },
    { label: "Religare", value: "Religare General Insurance" },
    { label: "digit", value: "Digit General Insurance" },
    { label: "reliance", value: "Reliance General Insurance" },
    { label: "MaxBupa", value: "Max Bupa Life Insurance" },
  ];
  const gradedDesignation_data = [
    { key: "SalaryBracket", value: "Salary Bracket" },
    { key: "Designation", value: "Designation" },
    { key: "Department", value: "Department" },
    { key: "Custom", value: "Custom" },
  ];
  const salary_bracket_data = [
    { key: "Below ₹ 1,00,000", year: "Below ₹ 1,00,000" },
    { key: "₹ 1,00,000 - ₹ 5,00,000", year: "₹ 1,00,000 - ₹ 5,00,000" },
    { key: "₹ 5,00,000 - ₹ 10,00,000", year: "₹ 5,00,000 - ₹ 10,00,000" },
    { key: "₹ 10,00,000 - ₹ 15,00,000", year: "₹ 10,00,000 - ₹ 15,00,000" },
    { key: "₹ 15,00,000 - ₹ 20,00,000", year: "₹ 15,00,000 - ₹ 20,00,000" },
    { key: "Above ₹ 20,00,000", year: "Above ₹ 20,00,000" },
  ];
  const deignation_one_data = [
    { key: "Ass. FrontEnd Developer", year: "Ass. FrontEnd Developer" },
    { key: "FrontEnd Developer", year: "FrontEnd Developer" },
    { key: "Ass. BackEnd Developer", year: "Ass. BackEnd Developer" },
    { key: "BackEnd Developer", year: "BackEnd Developer" },
  ];
  const department_one_data = [
    { key: "FrontEnd", year: "FrontEnd" },
    { key: "BackEnd", year: "BackEnd" },
    { key: "Marketing", year: "Marketing" },
    { key: "Finance", year: "Finance" },
    { key: "Corporate Communications", year: "Corporate Communications" },
  ];

  const maximumMember_data = [
    { key: "4", value: "4" },
    { key: "6", value: "6" },
    { key: "5", value: "5" },
    { key: "7", value: "7" },
    { key: "3", value: "3" },
  ];
  const maximumNominee_data = [
    { key: "4", value: "4" },
    { key: "3", value: "3" },
    { key: "2", value: "2" },
  ];
  const cardType_data = [
    { key: "E - Card", value: "E - Card" },
    { key: "Physical Card", value: "Physical Card" },
  ];
  const healthcardIssued_data = [
    {
      key: "Per Individual Member of the Family",
      value: "Per Individual Member of the Family",
    },
    { key: "Per Employee Only", value: "Per Employee Only" },
  ];
  const minage_data = [
    { label: "Up to 1 Year", value: "Up to 1 Year" },
    { label: "2 Years", value: "2 Years" },
    { label: "3 Years", value: "3 Years" },
    { label: "4 Years", value: "4 Years" },
  ];
  const maxage_data = [
    { label: "Up to 1 Year", value: "Up to 1 Year" },
    { label: "2 Years", value: "2 Years" },
    { label: "3 Years", value: "3 Years" },
    { label: "4 Years", value: "4 Years" },
  ];
  const [ageBandData, setAgeBandData] = useState<
    Array<{ min_age: string; max_age: string }>
  >([{ min_age: "", max_age: "" }]);

  const add_band_for_lives = (index: number) => {
    let data = [...ageBandData];
    data.splice(index + 1, 0, { min_age: "", max_age: "" });

    setAgeBandData(data);
  };

  const remove_band_for_lives = (index: number) => {
    let data = [...ageBandData];
    data.splice(index, 1);
    setAgeBandData(data);
  };

  return (
    <Box className="layoutWrapper">
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={12} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=quote");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <div>
            <h3>Add New Quotes</h3>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "organizationDetails"
                    ? "active sectionLink organizationDetails"
                    : "sectionLink organizationDetails"
                }
                onClick={() => {
                  scrollToSection(organizationDetails);
                  SetSectionStatus("organizationDetails");
                }}
              >
                <span>Organization Details</span>
              </Link>

              {/* <Link
                className={
                  sectionStatus === "products"
                    ? "active sectionLink products"
                    : "sectionLink products"
                }
                onClick={() => {
                  scrollToSection(products);
                  SetSectionStatus("products");
                }}>
                <span>Poduct Type</span>
              </Link> */}

              <Link
                className={
                  sectionStatus === "plantype"
                    ? "active sectionLink plantype"
                    : "sectionLink plantype"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(plantype);
                  SetSectionStatus("plantype");
                }}
              >
                <span>Coverage Type</span>
              </Link>

              <Link
                className={
                  sectionStatus === "EmployeeDetails"
                    ? "active sectionLink EmployeeDetails"
                    : "sectionLink EmployeeDetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(EmployeeDetails);
                  SetSectionStatus("EmployeeDetails");
                }}
              >
                <span>Employee Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "premiumdetails"
                    ? "active sectionLink premiumdetails"
                    : "sectionLink premiumdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(premiumdetails);
                  SetSectionStatus("premiumdetails");
                }}
              >
                <span>Premium Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "detailspolicy"
                    ? "active sectionLink detailspolicy"
                    : "sectionLink detailspolicy"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(detailspolicy);
                  SetSectionStatus("detailspolicy");
                }}
              >
                <span>Policy Details</span>
              </Link>

              {/* <Link
                className={
                  sectionStatus === "notes"
                    ? "active sectionLink notes"
                    : "sectionLink notes"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(notes);
                  SetSectionStatus("notes");
                }}>
                <span>Notes</span>
              </Link> */}
            </Grid>
            <Grid xs className="rightSection h-100">
              <Box className="detailSection" sx={{ height: "70px" }}>
                <Grid container spacing={1}>
                  <Grid xs={12} className="radio_group no-border mt-3">
                    <>
                      <RadioGroup row defaultValue="existing">
                        <FormControlLabel
                          value="existing"
                          control={<Radio />}
                          label="Existing Client"
                          onClick={handleClicktoogle}
                        />
                        <FormControlLabel
                          // checked
                          value="new"
                          control={<Radio />}
                          label="New Client"
                          onClick={handleClicked}
                        />
                      </RadioGroup>
                      {toggle == true ? (
                        <>
                          <div className="client_div">
                            <SearchDropdown
                              class_name="inputField"
                              title="Search Client ID"
                              value={clientID}
                              attrName={setClientID}
                              value_update={updateMasterState}
                              data={clientid_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </div>
                        </>
                      ) : null}
                    </>
                  </Grid>
                </Grid>
              </Box>
              {/* Organization Details */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  {toggle == true ? (
                    <>
                      <Box
                        className="detailSection mb-0"
                        ref={organizationDetails}
                      >
                        <div className="sectionTitle">
                          <h4>Organization Details</h4>
                        </div>
                        <Grid container spacing={3}>
                          <Grid xs={4}>
                            <p className="companyDetails">
                              Organization Name<span>Evervent pvt. Ltd.</span>
                            </p>
                          </Grid>
                          <Grid xs={4}>
                            <p className="companyDetails">
                              Industry - Sub-industry
                              <span>Information Technology-Production</span>
                            </p>
                          </Grid>
                          <Grid xs={4}>
                            <p className="companyDetails">
                              Ownership <span>Private Limited</span>
                            </p>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid xs={4}>
                            <p className="contactNumber">
                              <PhoneIphoneIcon />
                              +91 9876543210
                            </p>
                          </Grid>
                          <Grid xs={4}>
                            <Link
                              className="email_list"
                              href=""
                              target="_blank"
                            >
                              <EmailIcon />
                              www.example.com
                            </Link>
                          </Grid>
                          <Grid xs={4}>
                            <Link
                              className="email_list"
                              href=""
                              target="_blank"
                            >
                              <LanguageIcon />
                              www.example.com
                            </Link>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid xs={8}>
                            <MultipleSearchDropdown
                              class_name="inputField"
                              title="Locations"
                              value={locations}
                              attrName={setLocations}
                              value_update={updateMasterState}
                              multiple_data={locations_data}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  ) : null}

                  {toggle == false ? (
                    <>
                      <Box
                        className="detailSection mb-0"
                        ref={organizationDetails}
                      >
                        <div className="sectionTitle">
                          <h4>Organization Details</h4>
                        </div>
                        <Grid container spacing={3}>
                          <Grid xs={12} lg={6} xl={4}>
                            <RKTextField
                              class_name="inputField"
                              title="Organisation Name*"
                              value={organizationName}
                              attrName={setOrganizationName}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={12} lg={6} xl={3}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Ownership"
                              value={ownership}
                              attrName={setOwnership}
                              value_update={updateMasterState}
                              dropdown_data={ownership_data}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid xs={6} lg={4}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Industry"
                              value={industry}
                              attrName={setIndustry}
                              value_update={updateMasterState}
                              data={industry_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                          <Grid xs={6} lg={4}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Sub-Industry"
                              value={subIndustry}
                              attrName={setSubIndustry}
                              value_update={updateMasterState}
                              data={subIndustry_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid xs={12} lg={6} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title="Email"
                              value={email}
                              attrName={setEmail}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={12} lg={6} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title="Website URL"
                              value={websiteUrl}
                              attrName={setWebsiteUrl}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={12} lg={6} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title="contact No."
                              value={contactNo}
                              attrName={setContactNo}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  ) : null}
                </Grid>
              </Grid>
              <Grid container spacing={3} className="px-0">
                <Grid xs={12} style={{ paddingTop: "0px" }}>
                  <Grid container spacing={3} className="px-0">
                    <Grid xs={12}>
                      <Box className="detailSection mb-0" ref={products}>
                        <div className="sectionTitle">
                          <h4>Product Type</h4>
                        </div>
                        <Grid container spacing={3}>
                          <Grid className="productTypeSection">
                            <div className="radioBox productcategory">
                              <input
                                type="radio"
                                id="individual"
                                name="plantype"
                                defaultChecked
                              />
                              <label className="producttype grpTerm">
                                <hr />
                                Group Term Insurance
                              </label>
                            </div>
                          </Grid>
                          <Grid className="productTypeSection">
                            <div
                              className="radioBox"
                              onClick={() => {
                                setProductType("Health");
                              }}
                            >
                              <input
                                type="radio"
                                id="individual1"
                                name="plantype"
                              />
                              <label className="producttype grpHealth">
                                <hr />
                                Group Health Insurance
                              </label>
                            </div>
                          </Grid>
                          <Grid className="productTypeSection">
                            <div
                              className="radioBox"
                              onClick={() => {
                                setProductType("SuperTopup");
                              }}
                            >
                              <input
                                type="radio"
                                id="individual5"
                                name="plantype"
                              />
                              <label className="producttype grptopup">
                                <hr />
                                Group Super Topup Insurance
                                {/* <p>
                                  Group critical Illness helps employees prepare
                                  financially for an unexpected life event.
                                </p> */}
                              </label>
                            </div>
                          </Grid>
                          <Grid className="productTypeSection">
                            <div className="radioBox">
                              <input
                                type="radio"
                                id="individual2"
                                name="plantype"
                              />
                              <label className="producttype grpTravel">
                                <hr />
                                Group Travel Insurance
                              </label>
                            </div>
                          </Grid>
                          <Grid className="productTypeSection">
                            <div className="radioBox">
                              <input
                                type="radio"
                                id="individual3"
                                name="plantype"
                              />
                              <label className="producttype grpPA">
                                <hr />
                                Group Personal Accident
                              </label>
                            </div>
                          </Grid>
                          <Grid className="productTypeSection">
                            <div className="radioBox">
                              <input
                                type="radio"
                                id="individual4"
                                name="plantype"
                              />
                              <label className="producttype grpCI">
                                <hr />
                                Group Critical Illness
                              </label>
                            </div>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid xs={12}>
                  <Grid container spacing={3} className="px-0 py-0">
                    <Grid xs={12}>
                      <Box className="detailSection mb-0">
                        <div className="sectionTitle">
                          <h4>Policy Case</h4>
                        </div>
                        <Grid container spacing={3}>
                          <Grid xs={6} className="planTypeSection">
                            <div
                              className="radioBox plantype"
                              onClick={() => {
                                setPolicyType(0);
                              }}
                            >
                              <input type="radio" name="test" defaultChecked />
                              <label>Fresh Policy</label>
                            </div>
                          </Grid>
                          <Grid xs={6} className="planTypeSection">
                            <div
                              className="radioBox plantype"
                              onClick={() => {
                                setPolicyType(1);
                              }}
                            >
                              <input type="radio" name="test" />
                              <label>Renewal Policy</label>
                            </div>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* policy history */}
              {policyType === 1 ? <PolicyHistory /> : null}

              {/* plan type section */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={plantype}>
                    <Grid container spacing={3} className="px-0 py-0">
                      <Grid xs={12} className="pb-0">
                        <div className="sectionTitle">
                          <h4>Plan Type</h4>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid xs={4} className="planTypeSection">
                        <div className="radioBox plantype">
                          <input
                            type="radio"
                            name="radioButtonName"
                            defaultChecked
                            onClick={() => {
                              setPlanType(0);
                            }}
                          />
                          <label>
                            Flat Coverage
                            <span>
                              Common average amount for all employees in the
                              policy.
                            </span>
                          </label>
                        </div>
                      </Grid>
                      <Grid xs={4} className="planTypeSection">
                        <div className="radioBox plantype">
                          <input
                            type="radio"
                            name="radioButtonName"
                            onClick={() => {
                              setPlanType(1);
                            }}
                          />
                          <label>
                            Graded Coverage
                            <span>
                              Different average amount for different employees
                              in the policy.
                            </span>
                          </label>
                        </div>
                      </Grid>
                      {/* <Grid xs={4} className="planTypeSection">
                        <div className="radioBox plantype">
                          <input
                            type="radio"
                            name="radioButtonName"
                            onClick={() => {
                              setPlanType(2);
                            }}
                          />
                          <label>
                            Flexi
                            <span>
                              Lorem ipsum dolor sit amet this ready only text
                              here.
                            </span>
                          </label>
                        </div>
                      </Grid> */}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              {/* Coverage Details */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={plantype}>
                    <div className="sectionTitle">
                      <h4>Coverage Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        {/* Coverage Section */}
                        {planType === 0 || planType === 1 ? (
                          <Box className="coverageDetail">
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <h5 className="empsecHeading">
                                  Select Coverage Type
                                </h5>
                              </Grid>
                              <Grid xs={12}>
                                <ul className="coverageAmt">
                                  <li>
                                    <div className="Checkbox">
                                      <input
                                        type="checkbox"
                                        name="check"
                                        checked
                                      />
                                      <label className="employee">
                                        <p>Employee</p>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox ">
                                      <input
                                        type="checkbox"
                                        name="check"
                                        checked
                                      />
                                      <label className="spouse">
                                        <p>Spouse</p>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox ">
                                      <input
                                        type="checkbox"
                                        name="check"
                                        checked
                                      />
                                      <label className="kids">
                                        <p>Kids</p>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox ">
                                      <input type="checkbox" name="check" />
                                      <label className="parents">
                                        <p>Parents</p>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox ">
                                      <input type="checkbox" name="check" />
                                      <label className="parents">
                                        <p>Parents In Law</p>
                                      </label>
                                    </div>
                                  </li>
                                </ul>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <h5 className="subHeading">
                                  Coverage Configuration
                                </h5>
                              </Grid>
                              <Grid sm={6} md={4} lg={3} xl={3}>
                                <SelectDropdown
                                  class_name="inputField"
                                  title="Basic Configuration"
                                  value={basicConfiguration}
                                  attrName={setBasicConfiguration}
                                  value_update={updateMasterState}
                                  dropdown_data={basicConfig_data}
                                  warn_status={false}
                                />
                              </Grid>
                              <Grid sm={6} md={4} lg={3} xl={3}>
                                <SelectDropdown
                                  class_name="inputField"
                                  title="Individual Configuration"
                                  value={indvConfiguration}
                                  attrName={setIndvConfiguration}
                                  value_update={updateMasterState}
                                  dropdown_data={indvConfig_data}
                                  warn_status={false}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid sm={6} md={8} lg={5} xl={5}>
                                <RKTextField
                                  class_name="inputField"
                                  title="Family Definition"
                                  value={familyDefinition}
                                  attrName={setFamilyDefinition}
                                  value_update={updateMasterState}
                                  warn_status={false}
                                />
                              </Grid>
                            </Grid>
                            {planType === 1 ? (
                              <Grid container spacing={3}>
                                <Grid xs={12}>
                                  <h5 className="subHeading">
                                    Criterion for Grade Creation
                                  </h5>
                                </Grid>
                                <Grid sm={6} md={4} lg={3} xl={3}>
                                  <SelectDropdown
                                    class_name="inputField"
                                    title="Select Criterion"
                                    value={gradedDesignation}
                                    attrName={setGradedDesignation}
                                    value_update={updateMasterState}
                                    dropdown_data={gradedDesignation_data}
                                    warn_status={false}
                                  />
                                </Grid>
                                {gradedDesignation === "Others" ? (
                                  <Grid sm={6} md={4} lg={4} xl={3}>
                                    <RKTextField
                                      class_name="inputField"
                                      title="Other - Input grade Criteria"
                                      value={othersGraded}
                                      attrName={setOthersGraded}
                                      value_update={updateMasterState}
                                      warn_status={false}
                                    />
                                  </Grid>
                                ) : null}
                              </Grid>
                            ) : null}
                          </Box>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {/* payment configuration */}

              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection" ref={paymenttype}>
                    <div className="sectionTitle">
                      <h4>Premium Payment Configuration</h4>
                    </div>
                    <div className="premium_payment_section">
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Premium Payment Type</h5>
                        </Grid>
                        <Grid xs={12} className="payment_radio_group">
                          <>
                            <RadioGroup row defaultValue="new">
                              <FormControlLabel
                                value="existing"
                                control={<Radio />}
                                label="Standard Premium"
                                onClick={handleClickone}
                              />

                              <FormControlLabel
                                // checked
                                value="new"
                                control={<Radio />}
                                label="Split Premium"
                                onClick={handleClicktwo}
                              />
                            </RadioGroup>
                          </>
                        </Grid>
                      </Grid>
                      {toggle == true ? (
                        <Grid container spacing={3}>
                          <Grid sm={12} md={12} lg={6} xl={6}>
                            <div className="payment_inner_section">
                              <RKTextField
                                class_name="inputField"
                                title="Employee"
                                value={employeePayment}
                                attrName={setEmployeePayment}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                              <RKTextField
                                class_name="inputField"
                                title="Spouse"
                                value={spousePayment}
                                attrName={setSpousePayment}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                              <RKTextField
                                class_name="inputField"
                                title="Kids"
                                value={childrenPayment}
                                attrName={setChildrenPayment}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                              <RKTextField
                                class_name="inputField"
                                title="Parents"
                                value={parentsPayment}
                                attrName={setParentsPayment}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                              <RKTextField
                                class_name="inputField"
                                title="Parents In Law"
                                value={parentsinLawPayment}
                                attrName={setParentsInLawPayment}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      ) : null}
                      <Grid container spacing={3}>
                        <>
                          {toggle == false ? (
                            <Grid xs={12} className="pt-0">
                              <h6>
                                100% of the premium value will be paid by the
                                Client/Employer
                              </h6>
                            </Grid>
                          ) : null}

                          {toggle == true ? (
                            <Grid xs={12} className="pt-0">
                              <h6>
                                Define % of the premium value to be paid by the
                                employee for the respective associated
                                relationship
                              </h6>
                            </Grid>
                          ) : null}
                        </>
                      </Grid>
                    </div>
                  </Box>
                </Grid>
              </Grid>

              {/* premium payment section end */}

              {planType === 0 || planType === 1 ? (
                <Box className="detailSection ">
                  <div className="sectionTitle">
                    <h4>Age Bands for Lives</h4>
                  </div>
                  <Box className="band_lives">
                    <Grid container spacing={3}>
                      {ageBandData.map((data, index) => (
                        <Grid sm={12} md={12} lg={6} xl={6}>
                          <h5>Age Band {index + 1}</h5>
                          <div className="bandlives_inner">
                            <SearchDropdown
                              class_name="inputField"
                              title="Min Age"
                              value={data.min_age}
                              attrName={["setMinAge", "min_age"]}
                              value_update={updateMasterState}
                              data={minage_data}
                              warn_status={false}
                              error_message="Please select min age"
                            />
                            <SearchDropdown
                              class_name="inputField"
                              title="Max Age"
                              value={data.max_age}
                              attrName={["setMinAge", "max_age"]}
                              value_update={updateMasterState}
                              data={maxage_data}
                              warn_status={false}
                              error_message="Please select max age"
                            />
                            <div
                              className="actionBtns"
                              style={{ display: "flex" }}
                            >
                              <Link
                                className="blueBtn addfile ml-1"
                                sx={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  add_band_for_lives(index);
                                }}
                              />
                              {index === 0 ? null : (
                                <Link
                                  className="redBtn delete ml-1"
                                  sx={{
                                    textDecoration: "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => remove_band_for_lives(index)}
                                />
                              )}
                            </div>
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              ) : null}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0">
                    <div className="sectionTitle">
                      <h4>Plan Setting</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid
                        sm={12}
                        md={8}
                        lg={6}
                        className="switchFields"
                        display={"flex"}
                        alignItems="center"
                        sx={{ height: "70px" }}
                      >
                        <span>Corporate Buffer</span>
                        <input
                          type="checkbox"
                          className="switch ml-3"
                          onClick={toggleShowcorporate}
                        />
                        {toggle == showcorporate ? (
                          <div className="ml-2" style={{ width: "350px" }}>
                            <RKTextField
                              class_name="inputField"
                              title="Corporate Buffer Value"
                              value={corporatebufferValue}
                              attrName={setCorporateBufferValue}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </div>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  {/* for graded  section*/}
                  {planType === 0 ? (
                    <>
                      <Box className="detailSection mb-0">
                        <div className="sectionTitle">
                          <h4>Employees Details</h4>
                          <div className="actionBtns ">
                            {/* <Link
                            className="rounded_add_icons mr-3"
                            sx={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEmpGradeData((empGradeData) => [
                                ...empGradeData,
                                {
                                  sum_insured: "5000",
                                  emp_count: "5",
                                  features: ["sdf", "sdfsd"],
                                  deleteable: true,
                                },
                              ]);
                            }}>
                            Add Grade
                          </Link> */}
                            {/* <p className="lives">
                              Total Lives - <span> 300</span>
                            </p> */}
                          </div>
                        </div>
                        <Box className="employeeDetail">
                          {empGradeData.map((data, index) => (
                            <Grid
                              container
                              spacing={0}
                              className=" gradedSection ml-3 mr-3 mb-4"
                            >
                              <Grid xs={12} className="pb-3">
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    {productType === "SuperTopup" ? (
                                      <p>Select Super Top-Up Sum Insured</p>
                                    ) : (
                                      <p>Select Sum Insured</p>
                                    )}
                                  </Grid>

                                  <Grid xs={12}>
                                    <ul className="coverageAmt">
                                      <li>
                                        <div className="radioBox ">
                                          <input type="radio" name="coverage" />
                                          <label>1 Lakh</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input
                                            type="radio"
                                            name="coverage"
                                            defaultChecked
                                          />
                                          <label>2 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>3 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>4 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>5 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>6 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>7 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>8 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>9 Lakhs</label>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>10 Lakhs</label>
                                        </div>
                                      </li>
                                    </ul>
                                  </Grid>
                                  {/* <Grid xs={12} className="px-0">
                                    <Grid container spacing={3}>
                                      <Grid xs={12}>
                                        <p>Enter Lives Count</p>
                                      </Grid>
                                    </Grid>
                                    <Grid container spacing={3}>
                                      <Grid xs={6} xl={3}>
                                        <RKTextField
                                          class_name="inputField"
                                          title="Employee (18-80 yrs)"
                                          value={employeeAge}
                                          attrName={setEmployeeAge}
                                          value_update={updateMasterState}
                                          warn_status={false}
                                        />
                                      </Grid>
                                      <Grid xs={6} xl={3}>
                                        <RKTextField
                                          class_name="inputField"
                                          title="Spouse (18-80 yrs)"
                                          value={spouseAge}
                                          attrName={setSpouseAge}
                                          value_update={updateMasterState}
                                          warn_status={false}
                                        />
                                      </Grid>
                                      <Grid xs={6} xl={3}>
                                        <RKTextField
                                          class_name="inputField"
                                          title="Son (0-30 yrs)"
                                          value={sonAge}
                                          attrName={setSonAge}
                                          value_update={updateMasterState}
                                          warn_status={false}
                                        />
                                      </Grid>
                                      <Grid xs={6} xl={3}>
                                        <RKTextField
                                          class_name="inputField"
                                          title="Daughter (0-30 yrs)"
                                          value={daughterAge}
                                          attrName={setDaughterAge}
                                          value_update={updateMasterState}
                                          warn_status={false}
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid> */}
                                  <Grid xs={12}>
                                    <div className="sectionsHeading">
                                      <h6>Features</h6>
                                      <div className="actionBtns ">
                                        <Link
                                          className="rounded_add_icons mr-3"
                                          sx={{
                                            textDecoration: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setAddFeature(true);
                                          }}
                                        >
                                          Add
                                        </Link>
                                        <Link className="edit_btn">
                                          <img
                                            src="images/accordion_edit_icon.svg"
                                            alt=""
                                            className="edit_btn_icon"
                                          />
                                          Edit
                                        </Link>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Box className="featuresDetail px-0">
                                    <Grid container spacing={3}>
                                      <Grid xs={12}>
                                        <div className="features_list">
                                          <ul>
                                            <li>
                                              Pre-existing disease
                                              <span>3 years & Above</span>
                                            </li>
                                            <li>
                                              Room Rent
                                              <span>1% of SI</span>
                                            </li>
                                            <li>
                                              Ambulance Cover
                                              <span>
                                                ₹ 2000 per Hospitalization
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                  <Grid xs={12}>
                                    <div className="sectionsHeading">
                                      <h6>Exclusion</h6>
                                      <div className="actionBtns ">
                                        <Link
                                          className="rounded_add_icons mr-3"
                                          sx={{
                                            textDecoration: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setAddExclusion(true);
                                          }}
                                        >
                                          Add
                                        </Link>
                                        <Link className="edit_btn">
                                          <img
                                            src="images/accordion_edit_icon.svg"
                                            alt=""
                                            className="edit_btn_icon"
                                          />
                                          Edit
                                        </Link>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Box className="exclusionDetail px-0">
                                    <Grid container spacing={3}>
                                      <Grid xs={12}>
                                        <div className="features_list">
                                          <ul>
                                            <li>
                                              Surgeries
                                              <span>
                                                Any diagnosis of diseases /
                                                undergoing of surgery /
                                                occurrence of event, whose signs
                                                or symptoms first occur within
                                                30 days of Policy Period Start
                                                date.
                                              </span>
                                            </li>
                                            <li>
                                              Man-made Calamities
                                              <span>
                                                War, riot, strike, nuclear
                                                weapons induced hospitalisation.
                                              </span>
                                            </li>
                                            <li>
                                              Pregnancy and Child Birth
                                              <span>
                                                Treatment arising from or
                                                traceable to pregnancy and
                                                childbirth, miscarriage,
                                                abortion and its consequences.
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                  <Grid xs={12}>
                                    <div className="sectionsHeading">
                                      <h6>Voluntary Plan</h6>
                                      <div className="actionBtns ">
                                        <Link
                                          className="rounded_add_icons mr-3"
                                          sx={{
                                            textDecoration: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setSelectVoluntryPlans(true);
                                          }}
                                        >
                                          Add
                                        </Link>
                                        <Link className="edit_btn">
                                          <img
                                            src="images/accordion_edit_icon.svg"
                                            alt=""
                                            className="edit_btn_icon"
                                          />
                                          Edit
                                        </Link>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Box className="voluntaryplans px-0">
                                    <Grid container spacing={3}>
                                      <Grid xs={12}>
                                        <div className="features_list">
                                          <ul>
                                            <li>
                                              Surgeries
                                              <span>
                                                Any diagnosis of diseases /
                                                undergoing of surgery /
                                                occurrence of event, whose signs
                                                or symptoms first occur within
                                                30 days of Policy Period Start
                                                date.
                                              </span>
                                            </li>
                                            <li>
                                              Man-made Calamities
                                              <span>
                                                War, riot, strike, nuclear
                                                weapons induced hospitalisation.
                                              </span>
                                            </li>
                                            <li>
                                              Pregnancy and Child Birth
                                              <span>
                                                Treatment arising from or
                                                traceable to pregnancy and
                                                childbirth, miscarriage,
                                                abortion and its consequences.
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Grid>
                          ))}
                        </Box>
                      </Box>
                    </>
                  ) : planType === 1 || planType === 2 ? (
                    <Box className="detailSection mb-0" ref={EmployeeDetails}>
                      <div className="sectionTitle">
                        <h4>Employees Details</h4>
                        <div className="actionBtns ">
                          <Link
                            className="rounded_add_icons mr-3"
                            sx={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEmpGradeData((empGradeData) => [
                                ...empGradeData,
                                {
                                  sum_insured: "5000",
                                  emp_count: "5",
                                  features: ["sdf", "sdfsd"],
                                  deleteable: true,
                                },
                              ]);
                            }}
                          >
                            Add Grade
                          </Link>
                          {/* <p className="lives">
                            Total Lives - <span> 300</span>
                          </p> */}
                        </div>
                      </div>
                      <Box className="employeeDetail">
                        {empGradeData.map((data, index) => (
                          <Accordion
                            className="Accordion_section gradedSection gradepadding"
                            onChange={handleChange("panel1")}
                          >
                            <Grid container spacing={0}>
                              <Grid xs={4} className="px-0">
                                <AccordionSummary
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{
                                    display: "inline-block",
                                    width: "110px",
                                  }}
                                >
                                  <Typography
                                    className="title"
                                    style={{ width: "150px" }}
                                  >
                                    <h5>Grade {index + 1} :-</h5>
                                  </Typography>
                                </AccordionSummary>
                              </Grid>
                              <Grid
                                xs={8}
                                style={{
                                  alignSelf: "Center",
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <h4>Grade {index + 1} Lives - 150</h4>
                                {data.deleteable == false ? null : (
                                  <div
                                    className="text-right"
                                    style={{ alignSelf: "center" }}
                                  >
                                    <Link
                                      className="redBtn delete ml-3"
                                      underline="none"
                                      onClick={() => {
                                        setEmpGradeData((addFeature) =>
                                          empGradeData.filter(
                                            (_, i) => i !== index
                                          )
                                        );
                                      }}
                                    >
                                      Remove
                                    </Link>
                                  </div>
                                )}
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                >
                                  <Typography></Typography>
                                </AccordionSummary>
                              </Grid>
                            </Grid>

                            <AccordionDetails style={{ padding: "0" }}>
                              {/* Inner content */}
                              <Grid container spacing={0}>
                                <Grid xs={12} className="pb-3">
                                  <Grid container spacing={3}>
                                    <Grid xs={4}>
                                      {productType === "SuperTopup" ? (
                                        <p>Select Super Top-Up Sum Insured</p>
                                      ) : (
                                        <p>Select Sum Insured</p>
                                      )}
                                    </Grid>
                                    <Grid xs={8}>
                                      {gradedDesignation === "SalaryBracket" ? (
                                        <MultipleSearchDropdown
                                          class_name="inputField"
                                          title="Salary Brackets"
                                          value={salaryBracket}
                                          attrName={setSalaryBracket}
                                          value_update={updateMasterState}
                                          multiple_data={salary_bracket_data}
                                        />
                                      ) : null}
                                      {gradedDesignation === "Designation" ? (
                                        <MultipleSearchDropdown
                                          class_name="inputField"
                                          title="Designation"
                                          value={designationOne}
                                          attrName={setDesignationOne}
                                          value_update={updateMasterState}
                                          multiple_data={deignation_one_data}
                                        />
                                      ) : null}
                                      {gradedDesignation === "Department" ? (
                                        <MultipleSearchDropdown
                                          class_name="inputField"
                                          title="Department"
                                          value={departmentOne}
                                          attrName={setDepartmentOne}
                                          value_update={updateMasterState}
                                          multiple_data={department_one_data}
                                        />
                                      ) : null}
                                    </Grid>
                                    <Grid xs={12}>
                                      <ul className="coverageAmt">
                                        <li>
                                          <div className="radioBox ">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>1 Lakh</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                              defaultChecked
                                            />
                                            <label>2 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>3 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>4 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>5 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>6 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>7 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>8 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>9 Lakhs</label>
                                          </div>
                                        </li>

                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>10 Lakhs</label>
                                          </div>
                                        </li>
                                      </ul>
                                    </Grid>
                                    {/* <Grid xs={12} className="px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12} className="GradedLives">
                                          <p>Enter Lives Count</p>
                                          <p>
                                            Lives - <span>300</span>
                                          </p>
                                        </Grid>
                                      </Grid>
                                      <Grid container spacing={3}>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Employee (18-80 yrs)"
                                            value={employeeAge}
                                            attrName={setEmployeeAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Spouse (18-80 yrs)"
                                            value={spouseAge}
                                            attrName={setSpouseAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Son (0-30 yrs)"
                                            value={sonAge}
                                            attrName={setSonAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Daughter (0-30 yrs)"
                                            value={daughterAge}
                                            attrName={setDaughterAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid> */}
                                    {productType === "SuperTopup" ? (
                                      <Grid xs={6} className="super_topup">
                                        <h6>Deductible</h6>
                                        <div
                                          className="ml-3"
                                          style={{ width: "300px" }}
                                        >
                                          <RKTextField
                                            class_name="inputField"
                                            title="Enter value for Deductible"
                                            value={deductible}
                                            attrName={setDeductible}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </div>
                                      </Grid>
                                    ) : null}
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Features</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAddFeature(true);
                                            }}
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Box className="featuresDetail px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12}>
                                          <div className="features_list">
                                            <ul>
                                              <li>
                                                Pre-existing disease
                                                <span>3 years & Above</span>
                                              </li>
                                              <li>
                                                Room Rent
                                                <span>1% of SI</span>
                                              </li>
                                              <li>
                                                Ambulance Cover
                                                <span>
                                                  ₹ 2000 per Hospitalization
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Exclusion</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              setAddExclusion(true)
                                            }
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Box className="exclusionDetail px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12}>
                                          <div className="features_list">
                                            <ul>
                                              <li>
                                                Surgeries
                                                <span>
                                                  Any diagnosis of diseases /
                                                  undergoing of surgery /
                                                  occurrence of event, whose
                                                  signs or symptoms first occur
                                                  within 30 days of Policy
                                                  Period Start date.
                                                </span>
                                              </li>
                                              <li>
                                                Man-made Calamities
                                                <span>
                                                  War, riot, strike, nuclear
                                                  weapons induced
                                                  hospitalisation.
                                                </span>
                                              </li>
                                              <li>
                                                Pregnancy and Child Birth
                                                <span>
                                                  Treatment arising from or
                                                  traceable to pregnancy and
                                                  childbirth, miscarriage,
                                                  abortion and its consequences.
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Voluntary Plan</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAddFeature(true);
                                            }}
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Box className="voluntaryplans px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12}>
                                          <div className="features_list">
                                            <ul>
                                              <li>
                                                Surgeries
                                                <span>
                                                  Any diagnosis of diseases /
                                                  undergoing of surgery /
                                                  occurrence of event, whose
                                                  signs or symptoms first occur
                                                  within 30 days of Policy
                                                  Period Start date.
                                                </span>
                                              </li>
                                              <li>
                                                Man-made Calamities
                                                <span>
                                                  War, riot, strike, nuclear
                                                  weapons induced
                                                  hospitalisation.
                                                </span>
                                              </li>
                                              <li>
                                                Pregnancy and Child Birth
                                                <span>
                                                  Treatment arising from or
                                                  traceable to pregnancy and
                                                  childbirth, miscarriage,
                                                  abortion and its consequences.
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                            {/* </div> */}
                          </Accordion>
                        ))}
                      </Box>
                    </Box>
                  ) : null}
                  <SelectFeature
                    open_status={addFeature}
                    attrName={setAddFeature}
                    value_update={updateMasterState}
                  />
                  <Exclusion
                    open_status={Addexclusion}
                    attrName={setAddExclusion}
                    value_update={updateMasterState}
                  />
                  <SelectvoluntryPlans
                    open_status={selectvoluntryPlans}
                    attrName={setSelectVoluntryPlans}
                    value_update={updateMasterState}
                  />
                  {/* end for graded section */}
                </Grid>
              </Grid>
              {/* lives section */}

              {/* <Box className="detailSection">
                <div className="sectionTitle">
                  <h4>Lives Information</h4>
                  <div className="total_lives">
                    <p>
                      300 <span>Total Lives</span>
                    </p>
                  </div>
                </div>
                <div className="policy_lives">
                  <Grid container spacing={3}>
                    <Grid sm={12} md={8} lg={8} xl={9}>
                      {planType === 1 ? (
                        <ul className="coverageAmt">
                          <li>
                            <div className="radioBox ">
                              <input type="radio" name="coverages" />
                              <label>Grade 1</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 2</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input
                                type="radio"
                                name="coverages"
                                defaultChecked
                              />
                              <label>Grade 3</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 4</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 5</label>
                            </div>
                          </li>
                        </ul>
                      ) : null}
                    </Grid>

                    <Grid sm={12} md={2} lg={2} xl={1}>
                      {planType === 1 ? (
                        <RKTextField
                          class_name="inputField"
                          title="Grade 1 Lives"
                          value={gradeLives1}
                          attrName={setGradeLives1}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      ) : null}
                    </Grid>

                    <Grid sm={12} md={2} lg={2} xl={2}>
                      <RKTextField
                        class_name="inputField"
                        title="Sum Insured"
                        value={sumInsuredOne}
                        attrName={setSumInsuredOne}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <div className="table">
                        <div className="age-table">
                          <ul className="heading">
                            <li>0 - 18 yrs</li>
                            <li>19 yrs - 35 yrs</li>
                            <li>36 yrs - 45 yrs</li>
                            <li>46 yrs - 55 yrs</li>
                            <li>56 yrs - 60 yrs</li>
                            <li>61 yrs - 65 yrs</li>
                            <li>66 yrs - 70 yrs</li>
                            <li>71 yrs - 75 yrs</li>
                            <li>76 yrs - 80 yrs</li>
                          </ul>

                          {ageData.map((agemainData, agemainIndex) => (
                            <ul className="subheading">
                              {agemainData.map((agesubData, agesubIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={agesubData.value}
                                    attrName={[
                                      "ageData",
                                      agemainIndex,
                                      agesubIndex,
                                      agesubData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Box> */}
              {/* INSURER Details */}
              <Grid container spacing={3} className="px-0 lastsection">
                <Grid xs={12}>
                  <Box className="detailSection lastsection">
                    <div className="sectionTitle">
                      <h4>Insurer Details</h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setEmpGradeData((empGradeData) => [
                              ...empGradeData,
                              {
                                sum_insured: "5000",
                                emp_count: "5",
                                features: ["sdf", "sdfsd"],
                                deleteable: true,
                              },
                            ]);
                          }}
                        >
                          Add Insurer
                        </Link>
                      </div>
                    </div>

                    <>
                      {empGradeData.map((data, index) => (
                        <Grid container spacing={3}>
                          <Grid xs={5}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Select Insurer"
                              value={insurer1}
                              attrName={setInsurer1}
                              value_update={updateMasterState}
                              data={insurer_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                          <Grid xs={5}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Location"
                              value={location}
                              attrName={setLocation}
                              value_update={updateMasterState}
                              data={officeAddress_data}
                              warn_status={false}
                              error_message="Please select office address"
                            />
                          </Grid>

                          <Grid
                            xs={2}
                            style={{
                              alignSelf: "Center",
                              display: "flex",
                              justifyContent: "end",
                            }}
                          >
                            {data.deleteable == false ? null : (
                              <div
                                className="text-right"
                                style={{ alignSelf: "center" }}
                              >
                                <Link
                                  className="redBtn delete ml-3"
                                  underline="none"
                                  onClick={() => {
                                    setEmpGradeData((addFeature) =>
                                      empGradeData.filter((_, i) => i !== index)
                                    );
                                  }}
                                >
                                  Remove
                                </Link>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                      ))}
                    </>

                    {/* acoordion section of insurer detail  */}
                    {/* <Box className="employeeDetail w-100">
                      {empGradeData.map((data, index) => (
                        <Accordion
                          className="Accordion_section gradedSection gradepadding"
                          onChange={handleChange("panel1")}>
                          <Grid container spacing={0}>
                            <Grid xs={4} className="px-0">
                              <AccordionSummary
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{
                                  display: "inline-block",
                                }}>
                                <Typography
                                  className="title"
                                  style={{ width: "800px" }}>
                                  <h5>Insurer Name</h5>
                                </Typography>
                              </AccordionSummary>
                            </Grid>
                            <Grid
                              xs={8}
                              style={{
                                alignSelf: "Center",
                                display: "flex",
                                justifyContent: "end",
                              }}>
                              {data.deleteable == false ? null : (
                                <div
                                  className="text-right"
                                  style={{ alignSelf: "center" }}>
                                  <Link
                                    
                                    className="redBtn delete ml-3"
                                    underline="none"
                                    onClick={() => {
                                      setEmpGradeData((addFeature) =>
                                        empGradeData.filter(
                                          (_, i) => i !== index
                                        )
                                      );
                                    }}>
                                    Remove
                                  </Link>
                                </div>
                              )}
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header">
                                <Typography></Typography>
                              </AccordionSummary>
                            </Grid>
                          </Grid>

                          <AccordionDetails style={{ padding: "0" }}>
                         
                            <Grid container spacing={3}>
                              <Grid sm={12} md={6} lg={3} xl={3}>
                                <SearchDropdown
                                  class_name="inputField"
                                  title="Select Insurer"
                                  value={insurer1}
                                  attrName={setInsurer1}
                                  value_update={updateMasterState}
                                  data={insurer_data}
                                  warn_status={false}
                                  error_message="Please select client"
                                />
                              </Grid>
                              <Grid sm={12} md={6} lg={3} xl={3}>
                                <SearchDropdown
                                  class_name="inputField"
                                  title="Location"
                                  value={location}
                                  attrName={setLocation}
                                  value_update={updateMasterState}
                                  data={officeAddress_data}
                                  warn_status={false}
                                  error_message="Please select office address"
                                />
                              </Grid>
                              <Grid sm={12} md={6} lg={3} xl={3}>
                                <RKTextField
                                  class_name="inputField"
                                  title="Net Premium"
                                  value={netpremium1}
                                  attrName={setNetPremium1}
                                  value_update={updateMasterState}
                                  warn_status={false}
                                />
                              </Grid>
                              <Grid sm={12} md={6} lg={3} xl={3}>
                                <RKTextField
                                  class_name="inputField"
                                  title="Gross Premium"
                                  value={grosspremium1}
                                  attrName={setGrossPremium1}
                                  value_update={updateMasterState}
                                  warn_status={false}
                                />
                                <p className="small-text text-right">
                                  Tax @18% = ₹ 18,000
                                </p>
                              </Grid>
                              <Grid xs={12} style={{ textAlign: "right" }}>
                                <div className="actionBtns">
                                  <Link
                                    className="blueBtn addfile"
                                    sx={{
                                      textDecoration: "none",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => setUploadFile(true)}>
                                    Add Documents
                                  </Link>
                                </div>
                              </Grid>
                              <Grid xs={12}>
                                <Attachment
                                  open_status={attachment}
                                  attrName={setAttachment}
                                  value_update={updateMasterState}
                                />
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                          
                        </Accordion>
                      ))}
                    </Box> */}

                    {/* acoordion section of insurer detail End */}
                  </Box>
                </Grid>
              </Grid>

              {/* Notes Section */}
              {/* <Grid container spacing={3} className="px-0 lastsection">
                <Grid xs={12}>
                  <Box className="detailSection lastsection" ref={notes}>
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}>
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box>
                </Grid>
              </Grid> */}
            </Grid>
            {/* Footer Section */}
            <Grid container spacing={3} className="footerSection">
              <Grid xs={12} className="ctaBtn">
                <Button variant="outlined" className="borderBtn">
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  className="submitBtn"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Save & Send to Insurer
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AddNewQuotes;
